import { render, staticRenderFns } from "./FormCreateSearchableAttribute.vue?vue&type=template&id=6cfabef5&"
import script from "./FormCreateSearchableAttribute.vue?vue&type=script&lang=js&"
export * from "./FormCreateSearchableAttribute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports